import type { ModuleKey } from '@gty/common';

import { moduleLabel } from '../app/module-registry';
import { EmptyState } from '../ui/primitives';

/**
 * Placeholder for the 13 modules that are out of scope in Sprint 1.
 *
 * It sits INSIDE the module's real route guard, so a user who lacks the
 * permission sees `<Forbidden/>` here, not this. That makes guard behaviour for
 * all 14 modules live and testable before any of the screens exist.
 */
export function ComingSoon({ module }: { module: ModuleKey }): JSX.Element {
  return (
    <EmptyState
      title={moduleLabel(module)}
      description="This module isn't built yet. Your access to it is already configured, so it will appear here as soon as it ships."
    />
  );
}
